import { ShieldAlert } from "lucide-react";
import { Link } from "wouter";
import { Button } from "@/components/ui/button";

export function AccessDenied({ section }: { section?: string }) {
  return (
    <div
      className="flex flex-1 flex-col items-center justify-center gap-4 p-12 text-center"
      data-testid="access-denied"
    >
      <div className="rounded-full bg-rose-50 p-4 text-rose-600 dark:bg-rose-950">
        <ShieldAlert className="h-10 w-10" />
      </div>
      <h1 className="text-2xl font-semibold">Access Denied</h1>
      <p className="max-w-md text-sm text-muted-foreground">
        You don't have permission to view this section
        {section ? ` ("${section}")` : ""}. Ask an administrator to enable it
        for your account from the Admin → UI Access Control panel.
      </p>
      <Button asChild variant="outline">
        <Link href="/">Go to Dashboard</Link>
      </Button>
    </div>
  );
}
